import _ from 'lodash'
import { parse } from 'query-string'
import { isFeedieEmail } from '@feedyou/utils'

import { FeatureValues } from './types'
import { getTariffFeatures } from './featuresSchemaService'
import { Tariff } from './types.tariff'

export function expandTariffFeatures(
  features: FeatureValues,
  explicitFeatures: FeatureValues = {}
): FeatureValues {
  const tariff = features.TARIFF as Tariff | undefined

  if (!tariff) {
    return features
  }

  const tariffFeatures = getTariffFeatures(tariff)

  // we need to filter out explicitly set features to not be overwritten by the beta tariff
  const tariffFeaturesWithoutExplicit = _.omitBy(tariffFeatures, (_, key) =>
    Object.keys(explicitFeatures).includes(key)
  )

  return { ...tariffFeaturesWithoutExplicit, ...features }
}

export function shouldHaveAdminFeatures(email?: string): boolean {
  return isFeedieEmail(email) && !isAdminDisabledInUrl()
}

export function getAdminTariff(email?: string): FeatureValues {
  if (!shouldHaveAdminFeatures(email)) {
    return {}
  }

  return { TARIFF: 'premium' }
}

export function getAdminFeatures(email?: string): FeatureValues {
  if (!shouldHaveAdminFeatures(email)) {
    return {}
  }

  return { SHARE_MAX_ROLE: 'admin' }
}

export function isAdminDisabledInUrl(): boolean {
  const { noAdmin } = parse(window.location.search)

  // support bothkeyof ?noAdmin=1 or just ?noAdmin which leads to null param value
  return !!noAdmin || noAdmin === null
}

export function isAllowedToSetFeaturesFromUrl(): boolean {
  if (!isAdminDisabledInUrl()) {
    return false
  }

  if (isUrlWithToken()) {
    return false
  }

  return true
}

function isUrlWithToken(): boolean {
  const searchParsed = parse(window.location.search)

  if ('token' in searchParsed) {
    return false
  }

  return true
}
